import { PERSONALIZED_COURSES, courseRedirect } from '@lib/constants/booking'
import { destroyCookie, parseCookies } from 'nookies'
import type { NextPageContext } from 'next'

export const PERSONALIZED_COURSE_COOKIE_NAME = 'personalizedCourse'

type ReadContext = Pick<NextPageContext, 'req'> | null | undefined
type WriteContext = Pick<NextPageContext, 'res'> | null | undefined

type CourseParam = string | string[] | null | undefined

const toCourseSlug = (course: CourseParam): string | null => {
  if (!course) return null

  if (Array.isArray(course)) {
    return course[0] ?? null
  }

  return course
}

export const resolvePersonalizedCourse = (
  course: CourseParam
): string | null => {
  const slug = toCourseSlug(course)
  if (!slug) return null

  if (!PERSONALIZED_COURSES.includes(slug)) return null

  let resolvedSlug = slug
  while (courseRedirect[resolvedSlug]) {
    resolvedSlug = courseRedirect[resolvedSlug]
  }

  return resolvedSlug
}

export const isSpecializedPersonalizedCourse = (
  course: CourseParam
): course is string => {
  const resolvedSlug = resolvePersonalizedCourse(course)
  if (!resolvedSlug) return false

  return resolvedSlug !== 'coding'
}

export const getPersonalizedCourseFromCookie = (
  ctx: ReadContext = null
): string | null => {
  const cookies = parseCookies(ctx ?? undefined)
  const resolvedSlug = resolvePersonalizedCourse(
    cookies[PERSONALIZED_COURSE_COOKIE_NAME]
  )
  if (!resolvedSlug || resolvedSlug === 'coding') return null

  return resolvedSlug
}

export const clearPersonalizedCourseCookie = (
  ctx: WriteContext = null
): void => {
  destroyCookie(ctx, PERSONALIZED_COURSE_COOKIE_NAME, { path: '/' })
}
